import React from "react";
import { OnlyFansAccount } from "../../../../api/staff";

interface StatusCellProps {
  account: OnlyFansAccount;
}

/**
 * StatusCell Component
 *
 * Renders the account status chip with appropriate color
 *
 * Based on Figma design: Статус column
 */
const StatusCell: React.FC<StatusCellProps> = ({ account }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'active':
        return {
          label: 'Доступ активен',
          bgColor: '#17C964',
          textColor: '#17C964'
        };
      case 'verified':
        return {
          label: 'Верифицирован',
          bgColor: '#17C964',
          textColor: '#17C964'
        };
      case 'moderation':
        return {
          label: 'Модерация',
          bgColor: '#7828C8',
          textColor: '#7828C8'
        };
      case 'wait_media':
        return {
          label: 'Ожидание медиа',
          bgColor: '#F5A524',
          textColor: '#F5A524'
        };
      case 'deactivated':
        return {
          label: 'Деактивирован',
          bgColor: '#F31260',
          textColor: '#F31260'
        };
      default:
        return {
          label: 'Неизвестно',
          bgColor: '#71717A',
          textColor: '#71717A'
        };
    }
  };

  const statusConfig = getStatusConfig(account.status);

  return (
    <span
      className="inline-flex h-[24px] items-center justify-center rounded-lg px-[8px] text-[12px] font-medium whitespace-nowrap"
      style={{
        backgroundColor: `${statusConfig.bgColor}20`,
      }}
    >
      <div className="flex items-center gap-[4px]">
        <div
          className="w-[7px] h-[7px] rounded-full"
          style={{ backgroundColor: statusConfig.bgColor }}
        ></div>
        <span style={{ color: statusConfig.textColor }}>{statusConfig.label}</span>
      </div>
    </span>
  );
};

export default StatusCell;
